module.exports = __webpack_public_path__ + "static/media/HanWangMingMedium.67647521.svg";